import { ReactComponent as IconDate } from '@/assets/svgs/icon-date.svg'
import classname from 'classnames'
import { forwardRef } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker"
const DatePicker = ({ "data-testid": dataTestId, selectDate, setSelectDate, placeHolderText, disable, addClass, dateFormat = "dd/MM/yyyy h:mm aa", showTimeSelect = true, ...datePickerProps }) => {
	const placeholder = placeHolderText ? placeHolderText : "Select date and time"
	const datePickerClassName = classname(
		addClass,
		{
			date_picker__format: true
		}
	)

	const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
		<div data-testid={dataTestId} className={datePickerClassName} onClick={onClick} ref={ref}>
			{
				!value && (
					<>
						<IconDate />
						<span className="date_picker__selected-empty">
							{placeholder}
						</span>
					</>
				)
			}
			{
				value && (
					<span>
						{value}
					</span>
				)
			}
		</div>
	));


	return (
		<div className="date_picker__container">
			<ReactDatePicker
				isClearable
				{...datePickerProps}
				selected={selectDate}
				dateFormat={dateFormat}
				customInput={<CustomDateInput />}
				onChange={(date) => setSelectDate(date)}
				showTimeSelect={showTimeSelect}
				disabled={disable}
			/>
		</div>


	)
}

export default DatePicker
